/**
 * Coerce API enum values that may arrive as numeric or string (JsonStringEnumConverter).
 */
export function coerceEnumByLabel<T extends number>(
  value: unknown,
  labels: Record<string, T>,
): T | undefined {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value as T;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const asNumber = Number(trimmed);
    if (trimmed !== '' && !Number.isNaN(asNumber)) {
      return asNumber as T;
    }
    if (labels[trimmed] !== undefined) {
      return labels[trimmed];
    }
    const match = Object.entries(labels).find(
      ([label]) => label.toLowerCase() === trimmed.toLowerCase(),
    );
    if (match) {
      return match[1];
    }
  }
  return undefined;
}
